export default __webpack_public_path__ + "static/media/pexels-mikhail-nilov-9304680.8adfc05e.jpg";